import FDPBrochure from "../../assets/pdf/FDP_Broucher_2025.pdf"; // adjust path/file name if needed
import HeaderBanner from "../../components/HeaderBanner/index";

const FacultyDevelopmentProgramme = () => {
  // Page title for browser tab
  document.title =
    "FDP – AI Powered Tools & Techniques for Research and Teaching";

  return (
    <div>
      {/* Header Banner */}
      <HeaderBanner
        bgImage="Management"
        title="Faculty Development Programme"
        currentPage="AI Powered: Tools & Techniques for Research and Teaching"
      />

      {/* Spacer below banner */}
      <div className="bannerBotttom h-[3.5rem] w-full"></div>

      <div className="mx-auto max-w-[1300px] px-4 pb-10">
        {/* Main Heading */}
        <div className="primary-color mt-8 w-fit border-l-4 border-[#32727a] pl-3 text-2xl font-bold md:text-[45px]">
          One Week Faculty Development Programme
        </div>

        <p className="mt-3 text-lg font-semibold text-[#1d4e5f]">
          AI Powered: Tools &amp; Techniques for Research and Teaching
        </p>
        <p className="mt-1 text-base text-[#444]">
          11<sup>th</sup> December 2025 to 17<sup>th</sup> December 2025
        </p>
        <p className="mt-1 text-base text-[#444]">
          Organized by{" "}
          <span className="font-semibold">
            Lyallpur Khalsa College Technical Campus, Jalandhar
          </span>{" "}
          in association with{" "}
          <span className="font-semibold">
            Maharaja Agrasen University, Solan (HP)
          </span>{" "}
          &amp; <span className="font-semibold">IIT Delhi (Virtual Labs)</span>.
        </p>

        {/* Brochure & Registration */}
        <div className="mt-8 grid gap-6 md:grid-cols-2">
          <div>
            <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
              Brochure &amp; Registration
            </h2>
            <ul className="space-y-3 text-lg text-[#333333] list-disc pl-6">
              <li>
                <a
                  href={FDPBrochure}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0056b3] hover:underline"
                >
                  📄 Download FDP Brochure (2025)
                </a>
              </li>
              <li>
                <a
                  href="https://tinyurl.com/lkctc-fdp2025"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0056b3] hover:underline"
                >
                  🔗 Online Registration: https://tinyurl.com/lkctc-fdp2025
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
              Registration Fee
            </h2>
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="min-w-full text-left text-sm">
                <thead className="bg-gray-100 text-gray-700">
                  <tr>
                    <th className="px-4 py-2 font-semibold">Category</th>
                    <th className="px-4 py-2 font-semibold">
                      Registration Fee (₹)
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-800">
                  <tr className="border-t">
                    <td className="px-4 py-2">
                      Faculty Members &amp; Industry Delegates (Outside)
                    </td>
                    <td className="px-4 py-2">1200/-</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-2">
                      Faculty Members from LKCTC &amp; Sister Concerns
                    </td>
                    <td className="px-4 py-2">1000/-</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-2">Student Participants</td>
                    <td className="px-4 py-2">500/-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-3 text-sm text-[#555]">
              Payment can be made in cash or online through NEFT / UPI.
              Participants must email a copy of the fee receipt to{" "}
              <span className="font-semibold">fdp@lkcengg.edu.in</span>.
            </p>
          </div>
        </div>

        {/* About LKCTC */}
        <div className="mt-10">
          <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
            About LKCTC
          </h2>
          <p className="text-justify text-[16px] leading-relaxed text-[#333333]">
            Lyallpur Khalsa College Technical Campus (LKCTC), established in
            2010 under the aegis of Khalsa College Lyallpur Education Charitable
            Trust, is a premier institution offering professional programmes in
            Engineering, Technology, Management, Paramedical Sciences, Pharmacy,
            Hotel Management and Applied Sciences. The 6-acre lush green campus
            houses over 3,000 students and is equipped with state-of-the-art
            laboratories, modern infrastructure and a vibrant academic
            environment. LKCTC is a nodal centre for IIT Virtual Labs and ISRO
            IIRS, and actively promotes research, innovation and
            entrepreneurship through internships, startup incubators, bootcamps
            and innovation challenges.
          </p>
        </div>

        {/* Introduction */}
        <div className="mt-8">
          <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
            Introduction
          </h2>
          <p className="text-[16px] leading-relaxed text-[#333333] text-justify">
            Artificial Intelligence (AI) is redefining education through
            personalized learning, automated assessment and intelligent content
            creation tools. To remain effective in a rapidly evolving academic
            landscape, educators must adopt AI-driven pedagogy. This FDP is
            designed to provide faculty members with conceptual understanding
            and hands-on exposure to AI tools and techniques for enhancing
            teaching, learning and research practices.
          </p>
        </div>

        {/* Objectives */}
        <div className="mt-8">
          <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
            Objectives
          </h2>
          <ul className="list-disc space-y-2 pl-6 text-[16px] text-[#333333]">
            <li>
              Familiarize participants with AI pedagogy tools and digital
              teaching platforms.
            </li>
            <li>
              Provide strategies for designing interactive and adaptive learning
              experiences.
            </li>
            <li>
              Equip educators with AI-driven content creation, assessment and
              evaluation techniques to enhance classroom effectiveness.
            </li>
            <li>
              Offer hands-on exposure to AI tools for research and academic
              productivity.
            </li>
            <li>
              Promote collaboration and sharing of best practices in AI-based
              pedagogy.
            </li>
          </ul>
        </div>

        {/* Target Participants */}
        <div className="mt-8">
          <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
            Target Participants
          </h2>
          <p className="text-[16px] leading-relaxed text-[#333333]">
            Faculty members, students, academicians and researchers from
            Engineering, Computer Science, Management, Applied Sciences,
            Pharmacy, Allied Health Sciences, Hotel Management, Agriculture,
            Law, Education and related disciplines.
          </p>
        </div>

        {/* Key Themes */}
        <div className="mt-8">
          <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
            Key Themes / Areas to be Covered
          </h2>
          <ol className="list-decimal space-y-2 pl-6 text-[16px] text-[#333333]">
            <li>Introduction to AI in Education</li>
            <li>
              AI Tools for Teaching and Learning (ChatGPT, Copilot, Adaptive
              Platforms)
            </li>
            <li>AI in Curriculum Design and Content Development</li>
            <li>AI-driven Assessment and Evaluation</li>
            <li>Academic Research and Writing with AI Tools</li>
            <li>Responsible and Ethical Use of AI in Education</li>
            <li>Hands-on Workshops and Case Studies</li>
          </ol>
        </div>

        {/* Duration & Methodology */}
        <div className="mt-8 grid gap-6 md:grid-cols-2">
          <div>
            <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
              Duration &amp; Mode
            </h2>
            <ul className="list-disc space-y-2 pl-6 text-[16px] text-[#333333]">
              <li>Duration: One Week (11th – 17th December 2025)</li>
              <li>Mode: Offline</li>
              <li>
                Certificates will be awarded on successful completion of the
                FDP.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
              Methodology
            </h2>
            <ul className="list-disc space-y-2 pl-6 text-[16px] text-[#333333]">
              <li>
                Expert lectures and keynote sessions by distinguished resource
                persons.
              </li>
              <li>Demonstrations of AI pedagogy tools.</li>
              <li>Hands-on practice workshops.</li>
              <li>
                Group activities, discussions and case studies based on
                real-time applications.
              </li>
            </ul>
          </div>
        </div>

        {/* Payment Details */}
        <div className="mt-8">
          <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">
            Payment Details
          </h2>
          <p className="text-[16px] text-[#333333]">
            Payment can be made in cash or online through NEFT / UPI using the
            following account:
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-6 text-[16px] text-[#333333]">
            <li>
              <span className="font-semibold">Bank Name:</span> Punjab &amp;
              Sind Bank
            </li>
            <li>
              <span className="font-semibold">Account Name:</span> LKCE TECHNO
              CLUB
            </li>
            <li>
              <span className="font-semibold">Account Number:</span>{" "}
              07141000085365
            </li>
            <li>
              <span className="font-semibold">IFSC Code:</span> PSIB0000714
            </li>
          </ul>
          <p className="mt-2 text-sm text-[#555]">
            Note: Participants are required to send a copy of the fee receipt to{" "}
            <span className="font-semibold">fdp@lkcengg.edu.in</span>.
          </p>
        </div>

        {/* Contact */}
        <div className="mt-8">
          <h2 className="mb-3 text-xl font-semibold text-[#1d4e5f]">Contact</h2>
          <p className="text-[16px] text-[#333333]">
            For any queries, contact:{" "}
            <span className="font-semibold">
              9872476060, 9914320506, 9888861422
            </span>
          </p>
          <p className="mt-1 text-[16px] text-[#333333]">
            Website: <span className="font-semibold">lkctc.edu.in</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FacultyDevelopmentProgramme;
